<header class="header">
  <div class="arrow-button" onclick="history.back()"></div>
  <p class="text-h5">パスワードの再設定</p>
</header>
<div *ngIf="page === 'forgot-password'">
  <div class="container isBackgoround">
    <main>
      <div
        class="container_min v-application v-application--is-ltr theme--light"
      >
        <form style="width: 100%; margin-top: 100px">
          <!-- <div class="text-center mb-10">
            <p style="text-align: left" class="v-text">
              下記に登録したメールアドレスを入力してください。パスワード再設定のご案内をメールでお送りします。
            </p>
          </div> -->
          <h1 class="mb-10 h3">パスワード再設定</h1>
          認証情報は以下のシステムで共通となります。<br>
          　・登録支援システム<br>
          　・処方元情報システム<br>
          　・SGマスタ<br>
          <div
            class="v-input v-input--is-label-active v-input--is-dirty v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
          >
            <div class="v-input__control">
              <label for="input-13" class="bold">メールアドレス</label>
              <div class="v-input__slot">
                <input
                  (focus)="focus(inputState.email)"
                  (blur)="blur(inputState.email)"
                  id="input-13"
                  name="input-13"
                  type="email"
                  [(ngModel)]="email"
                />
              </div>
              <div class="v-text-field__details">
                <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
                <div class="v-messages theme--light error--text">
                  <div
                    *ngIf="errorMessages.forgetpassword.email"
                    class="v-messages__wrapper"
                  >
                    {{ errorMessages.forgetpassword.email }}

                    <!-- 注釈及びエラーテキストが入ります。 -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center mb-6">
            <button
              type="button"
              class="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary primary-button"
              medium=""
              (click)="changePassword()"
            >
              <span class="v-btn__content bold"> 再設定リンクを送信 </span>
            </button>
          </div>
          <div style="justify-content: center; display: flex">
            <a (click)="navigate('login')" class="text-link v-text-caption">
              ログイン
            </a>
          </div>
        </form>
      </div>
    </main>
  </div>
</div>